// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var DebugBinParent = /** @class */ (function () {
    function DebugBinParent(parent, children, bottomDistance, prefix) {
        this.parent = parent;
        this.children = children;
        this.showChildren = false;
        this.value = 0;
        var _self = this;
        _self.el = document.createElement("div");
        _self.el.setAttribute("tabindex", "0");
        _self.el.className = prefix + "-debug-bin-parent";
        _self.el.style.bottom = 20 + bottomDistance + "px";
        _self.elSpan = document.createElement("span");
        _self.elSpan.innerText = "" + _self.value;
        _self.elSpan.setAttribute("data-name", "AppInsights");
        _self.el.appendChild(_self.elSpan);
        _self.el.onclick = function () {
            _self.showChildren = !_self.showChildren;
            _self.el.className = (_self.showChildren) ? prefix + "-debug-bin-parent active" : prefix + "-debug-bin-parent";
            _self.render();
        };
        _self.el.onkeydown = function (evt) {
            if (evt.which === 13 || evt.which === 32) {
                evt.preventDefault();
                evt.target.click();
            }
        };
        _self.render();
    }
    DebugBinParent.prototype.addClassToEl = function (name) {
        var _self = this;
        if (_self.el.className.indexOf(name) === -1) {
            _self.el.className += " " + name;
        }
    };
    DebugBinParent.prototype.addChild = function (bin) {
        this.children.push(bin);
    };
    DebugBinParent.prototype.addButton = function (handler, label) {
        var btn = document.createElement("button");
        btn.innerText = label;
        btn.onclick = handler;
        this.addChild(btn);
    };
    DebugBinParent.prototype.increment = function () {
        var _self = this;
        _self.elSpan.innerText = "" + ++_self.value;
    };
    DebugBinParent.prototype.render = function () {
        var _self = this;
        if (!_self.el.parentElement) {
            _self.parent.appendChild(_self.el);
        }
        for (var _i = 0, _a = _self.children; _i < _a.length; _i++) {
            var ch = _a[_i];
            if (ch instanceof DebugBin) {
                if (ch.el.parentElement !== _self.el && _self.showChildren) {
                    _self.el.appendChild(ch.el);
                }
                else if (ch.el.parentElement === _self.el && !_self.showChildren) {
                    _self.el.removeChild(ch.el);
                }
            }
            else {
                if (_self.showChildren) {
                    _self.el.appendChild(ch);
                }
                else {
                    _self.el.removeChild(ch);
                }
            }
        }
    };
    return DebugBinParent;
}());
export { DebugBinParent };
var DebugBin = /** @class */ (function () {
    function DebugBin(name, value, parent, bottomDistance, backgroundColor) {
        this.name = name;
        this.value = value;
        this.parent = parent;
        var _self = this;
        parent.addChild(_self);
        _self.el = document.createElement("div");
        _self.elName = document.createElement("span");
        _self.elName.innerText = name + ": ";
        _self.elName.className = "el-name";
        _self.el.appendChild(_self.elName);
        _self.elValue = document.createElement("span");
        _self.elValue.innerText = "" + value;
        _self.elValue.className = "el-value";
        _self.el.appendChild(_self.elValue);
    }
    DebugBin.prototype.increment = function () {
        var _self = this;
        _self.elValue.innerText = "" + ++_self.value;
        _self.parent.increment();
        _self.elValue.className = "el-value incremented";
        setTimeout(function () { return _self.elValue.className = "el-value"; }, 1);
    };
    return DebugBin;
}());
export { DebugBin };
//# sourceMappingURL=debugBins.js.map